<div class="d-flex align-items-center justify-content-center" style="height: 600px">
    <div class="text-center">
        <h1 class="w3-jumbo w3-animate-top w3-center"><code>Access Denied</code></h1>
        <hr class="w3-border-white w3-animate-left" style="margin:auto;width:50%">
        <h3 class="w3-center w3-animate-right">You dont have permission to view this site.</h3>
        <h3 class="w3-center w3-animate-zoom">🚫🚫🚫🚫</h3>
        <h6 class="w3-center w3-animate-zoom">error code:403 forbidden</h6>
        <button class="btn btn-primary" (click)="logout()" > Signout</button>
    </div>
</div>